var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { yupResolver } from '@hookform/resolvers/yup';
import { LoadingButton } from '@mui/lab';
import { Box, Button, Checkbox, DialogActions, DialogContent, DialogTitle, FormControlLabel, Grid, Radio, Switch, TextField, Typography } from '@mui/material';
import moment from 'moment';
import { useEffect, useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';
import { StyledDialog } from '.';
import { dateToString } from '../../util';
import { useUserSessionAPI } from '../app/selectors';
import { Autocomplete, DatePicker, ErrorMessageBox, FallbackComponent, FieldLabel, NumberInput, PhoneInput, RadioGroup } from '../common';
import { FormField } from '../common/formField';
import { useAddCompanyAPI, useCompaniesAPI, useCompanyAPI, useCountryAPI, useIndustryAPI, useUpdateCompanyAPI } from './selectors';
import { LicenseType } from './types';
export var CompanyDialog = function (_a) {
  var _b;
  var user = _a.user,
    open = _a.open,
    onClose = _a.onClose,
    onUserSaved = _a.onUserSaved;
  var t = useTranslation(['manageUser', 'translation']).t;
  var orgId = (_b = user === null || user === void 0 ? void 0 : user.orgs[0]) === null || _b === void 0 ? void 0 : _b.id;
  var _c = useCountryAPI(),
    countries = _c[0],
    fetchCountries = _c[1],
    clearCountries = _c[2];
  var _d = useIndustryAPI(),
    industry = _d[0],
    fetchIndustry = _d[1],
    clearIndustry = _d[2];
  var _e = useCompanyAPI(orgId),
    orgData = _e[0],
    fetchOrgData = _e[1],
    clearOrgData = _e[2];
  var _f = useAddCompanyAPI(),
    addCompanyData = _f[0],
    addCompany = _f[1],
    clearAddCompanyData = _f[2];
  var _g = useUpdateCompanyAPI(orgId),
    updateCompanyData = _g[0],
    updateCompany = _g[1],
    clearUpdateCompanyData = _g[2];
  var _h = useUserSessionAPI(),
    fetchUserSessionData = _h[1];
  var _j = useCompaniesAPI(),
    fetchOrgs = _j[1];
  var defaultValues = useMemo(function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6;
    return {
      name: (_b = (_a = orgData.data) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : '',
      countryId: (_d = (_c = orgData.data) === null || _c === void 0 ? void 0 : _c.countryId) !== null && _d !== void 0 ? _d : null,
      industryId: (_f = (_e = orgData.data) === null || _e === void 0 ? void 0 : _e.industryId) !== null && _f !== void 0 ? _f : null,
      contactPhone: (_h = (_g = orgData.data) === null || _g === void 0 ? void 0 : _g.contactPhone) !== null && _h !== void 0 ? _h : '',
      contactName: (_k = (_j = orgData.data) === null || _j === void 0 ? void 0 : _j.contactName) !== null && _k !== void 0 ? _k : '',
      contactEmail: (_m = (_l = orgData.data) === null || _l === void 0 ? void 0 : _l.contactEmail) !== null && _m !== void 0 ? _m : '',
      subscriptionStartDate: ((_o = orgData.data) === null || _o === void 0 ? void 0 : _o.subscriptionStartDate) ? moment.utc(orgData.data.subscriptionStartDate) : moment().utc().startOf('d'),
      subscriptionEndDate: ((_p = orgData.data) === null || _p === void 0 ? void 0 : _p.subscriptionEndDate) ? moment.utc((_q = orgData.data) === null || _q === void 0 ? void 0 : _q.subscriptionEndDate).endOf('D') : moment().utc().endOf('y'),
      capacityLicense: LicenseType.Yes,
      recruitmentLicense: (_s = (_r = orgData.data) === null || _r === void 0 ? void 0 : _r.recruitmentLicense) !== null && _s !== void 0 ? _s : LicenseType.No,
      financialLicense: (_u = (_t = orgData.data) === null || _t === void 0 ? void 0 : _t.financialLicense) !== null && _u !== void 0 ? _u : LicenseType.No,
      actualLicense: (_w = (_v = orgData.data) === null || _v === void 0 ? void 0 : _v.actualLicense) !== null && _w !== void 0 ? _w : LicenseType.No,
      dashboardLicense: (_y = (_x = orgData.data) === null || _x === void 0 ? void 0 : _x.dashboardLicense) !== null && _y !== void 0 ? _y : LicenseType.No,
      licensesUnlimited: (_0 = (_z = orgData.data) === null || _z === void 0 ? void 0 : _z.licensesUnlimited) !== null && _0 !== void 0 ? _0 : LicenseType.No,
      numberOfLicenses: (_4 = (_2 = (_1 = orgData.data) === null || _1 === void 0 ? void 0 : _1.numberOfLicenses) !== null && _2 !== void 0 ? _2 : (_3 = orgData.data) === null || _3 === void 0 ? void 0 : _3.usedLicenses) !== null && _4 !== void 0 ? _4 : null,
      multiGeoEnabled: !!((_5 = orgData.data) === null || _5 === void 0 ? void 0 : _5.multiGeoEnabled),
      ssoEnabled: !!((_6 = orgData.data) === null || _6 === void 0 ? void 0 : _6.ssoEnabled)
    };
  }, [orgData.data]);
  var validateForm = yup.object().shape({
    name: yup.string().required().normalizeSpace(),
    countryId: yup.number().required(),
    industryId: yup.number().required(),
    capacityLicense: yup.number().required(),
    financialLicense: yup.number().required(),
    recruitmentLicense: yup.number().required(),
    actualLicense: yup.number().required(),
    dashboardLicense: yup.number().required(),
    subscriptionStartDate: yup.object().nullable().required(),
    subscriptionEndDate: yup.object().nullable().required(),
    subscriptionEndDateError: yup.string().optional().max(0, 'Invalid'),
    subscriptionStartDateError: yup.string().optional().max(0, 'Invalid'),
    contactName: yup.string().required().max(50).normalizeSpace().label('Name'),
    contactPhone: yup.string().max(20).phone().trim().label('Phone'),
    contactEmail: yup.string().email().required().max(50).trim().label('Email'),
    licensesUnlimited: yup.number().required(),
    numberOfLicenses: yup.number().when('licensesUnlimited', function (val, schema) {
      if (!Number(val)) return schema.required();
      return schema.notRequired().nullable();
    }),
    ssoEnabled: yup.boolean().optional()
  });
  var _k = useForm({
      defaultValues: defaultValues,
      resolver: yupResolver(validateForm)
    }),
    control = _k.control,
    handleSubmit = _k.handleSubmit,
    reset = _k.reset,
    watch = _k.watch,
    setValue = _k.setValue;
  var _l = watch(),
    subscriptionStartDate = _l.subscriptionStartDate,
    recruitmentLicense = _l.recruitmentLicense,
    capacityLicense = _l.capacityLicense,
    financialLicense = _l.financialLicense,
    actualLicense = _l.actualLicense,
    dashboardLicense = _l.dashboardLicense,
    licensesUnlimited = _l.licensesUnlimited,
    multiGeoEnabled = _l.multiGeoEnabled;
  useEffect(function () {
    if (open) {
      orgId && fetchOrgData();
      fetchCountries();
      fetchIndustry();
      return function () {
        clearOrgData();
        clearCountries();
        clearIndustry();
        clearAddCompanyData();
        clearUpdateCompanyData();
      };
    }
  }, [clearAddCompanyData, clearCountries, clearIndustry, clearOrgData, clearUpdateCompanyData, fetchCountries, fetchIndustry, fetchOrgData, open, orgId]);
  useEffect(function () {
    if (open) {
      reset(defaultValues);
    }
  }, [defaultValues, open, reset]);
  useEffect(function () {
    if (addCompanyData.data || updateCompanyData.data) {
      onClose();
      fetchOrgs();
      onUserSaved === null || onUserSaved === void 0 ? void 0 : onUserSaved({
        created: !!addCompanyData.data
      });
      if (updateCompanyData.data) fetchUserSessionData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addCompanyData.data, fetchOrgs, onClose, fetchUserSessionData, updateCompanyData.data]);
  var handleFormSubmit = function (_a) {
    var startDate = _a.subscriptionStartDate,
      endDate = _a.subscriptionEndDate,
      values = __rest(_a, ["subscriptionStartDate", "subscriptionEndDate"]);
    var payload = __assign(__assign({}, values), {
      subscriptionStartDate: dateToString(startDate),
      subscriptionEndDate: dateToString(endDate),
      ssoEnabled: values.ssoEnabled
    });
    if (orgId) {
      updateCompany(__assign({}, payload));
    } else {
      addCompany(payload);
    }
  };
  return _jsx(StyledDialog, __assign({
    open: open,
    onClose: onClose
  }, {
    children: _jsxs(Box, __assign({
      component: "form",
      onSubmit: handleSubmit(handleFormSubmit)
    }, {
      children: [_jsx(DialogTitle, __assign({
        variant: "h2"
      }, {
        children: t(orgId ? 'editCompanyTittle' : 'addNewCompanyTittle')
      })), _jsx(DialogContent, {
        children: _jsxs(FallbackComponent, __assign({
          requesting: (addCompanyData.requesting, orgData.requesting),
          overlay: true
        }, {
          children: [_jsx(ErrorMessageBox, {
            errors: [addCompanyData.error, updateCompanyData.error]
          }), _jsxs(Grid, __assign({
            container: true,
            spacing: 4
          }, {
            children: [_jsx(Grid, __assign({
              item: true,
              xs: 6
            }, {
              children: _jsx(FormField, __assign({
                required: true,
                name: "name",
                label: t('company'),
                control: control
              }, {
                children: _jsx(TextField, {
                  inputProps: {
                    maxLength: 50
                  }
                })
              }))
            })), _jsx(Grid, __assign({
              item: true,
              xs: 6
            }, {
              children: _jsx(FormField, __assign({
                required: true,
                name: "countryId",
                label: t('country'),
                control: control
              }, {
                children: _jsx(Autocomplete, {
                  options: countries.data,
                  placeholder: t('pleaseSelect'),
                  loading: countries.requesting
                })
              }))
            })), _jsx(Grid, __assign({
              item: true,
              xs: 6
            }, {
              children: _jsx(FormField, __assign({
                required: true,
                name: "subscriptionStartDate",
                label: t('subscriptionStartDate'),
                control: control
              }, {
                children: _jsx(DatePicker, {
                  disableFuture: true,
                  control: control,
                  disabled: false
                })
              }))
            })), _jsx(Grid, __assign({
              item: true,
              xs: 6
            }, {
              children: _jsx(FormField, __assign({
                required: true,
                name: "subscriptionEndDate",
                label: t('subscriptionEndDate'),
                control: control
              }, {
                children: _jsx(DatePicker, {
                  minDate: subscriptionStartDate,
                  control: control,
                  disabled: false
                })
              }))
            })), _jsx(Grid, __assign({
              item: true,
              xs: 6
            }, {
              children: _jsx(FormField, __assign({
                required: true,
                name: "contactName",
                label: t('contactName'),
                control: control
              }, {
                children: _jsx(TextField, {
                  inputProps: {
                    maxLength: 50
                  }
                })
              }))
            })), _jsx(Grid, __assign({
              item: true,
              xs: 6
            }, {
              children: _jsx(FormField, __assign({
                required: true,
                name: "contactEmail",
                label: t('contactEmail'),
                control: control
              }, {
                children: _jsx(TextField, {
                  type: "email",
                  inputProps: {
                    maxLength: 50
                  }
                })
              }))
            })), _jsx(Grid, __assign({
              item: true,
              xs: 6
            }, {
              children: _jsx(FieldLabel, {
                label: t('contactPhone')
              })
            })), _jsx(Grid, __assign({
              item: true,
              xs: 6
            }, {
              children: _jsx(FieldLabel, {
                required: true,
                label: t('industry')
              })
            })), _jsx(Grid, __assign({
              item: true,
              xs: 6,
              sx: {
                paddingTop: '0.3rem !important'
              }
            }, {
              children: _jsx(FormField, __assign({
                name: "contactPhone",
                control: control
              }, {
                children: _jsx(PhoneInput, {
                  "data-testid": "phoneInput"
                })
              }))
            })), _jsx(Grid, __assign({
              item: true,
              xs: 6,
              sx: {
                paddingTop: '0.3rem !important'
              }
            }, {
              children: _jsx(FormField, __assign({
                required: true,
                name: "industryId",
                control: control
              }, {
                children: _jsx(Autocomplete, {
                  options: industry.data,
                  placeholder: t('pleaseSelect'),
                  loading: industry.requesting
                })
              }))
            })), _jsxs(Grid, __assign({
              item: true,
              xs: 12
            }, {
              children: [_jsx(FieldLabel, {
                label: t('manageUser:ssoSignOnLabel')
              }), _jsx(FormControlLabel, {
                control: _jsx(Switch, {
                  color: "primary",
                  checked: !!watch('ssoEnabled'),
                  onChange: function (e) {
                    return setValue('ssoEnabled', e.target.checked, {
                      shouldValidate: true
                    });
                  }
                }),
                label: t('manageUser:ssoSignOn'),
                labelPlacement: "start"
              })]
            })), _jsxs(Grid, __assign({
              container: true,
              item: true,
              xs: 12,
              display: "flex",
              spacing: 4
            }, {
              children: [_jsxs(Grid, __assign({
                item: true,
                xs: 6
              }, {
                children: [_jsxs(Typography, __assign({
                  variant: "subtitle2"
                }, {
                  children: [" ", t('licenseInfo')]
                })), _jsx(Grid, {
                  children: _jsx(FormControlLabel, {
                    control: _jsx(Checkbox, {
                      size: "small",
                      disabled: true,
                      checked: !!capacityLicense,
                      onChange: function (e, checked) {
                        return setValue('capacityLicense', checked ? LicenseType.Yes : LicenseType.No, {
                          shouldValidate: true
                        });
                      }
                    }),
                    label: t('capacityPlanning')
                  })
                }), _jsx(Grid, {
                  children: _jsx(FormControlLabel, {
                    control: _jsx(Checkbox, {
                      size: "small",
                      checked: !!financialLicense,
                      onChange: function (e, checked) {
                        return setValue('financialLicense', checked ? LicenseType.Yes : LicenseType.No, {
                          shouldValidate: true
                        });
                      }
                    }),
                    label: t('financials')
                  })
                }), _jsx(Grid, {
                  children: _jsx(FormControlLabel, {
                    control: _jsx(Checkbox, {
                      size: "small",
                      checked: !!recruitmentLicense,
                      onChange: function (e, checked) {
                        return setValue('recruitmentLicense', checked ? LicenseType.Yes : LicenseType.No, {
                          shouldValidate: true
                        });
                      }
                    }),
                    label: t('recruitmentAndTrainingPlanner')
                  })
                }), _jsx(Grid, {
                  children: _jsx(FormControlLabel, {
                    control: _jsx(Checkbox, {
                      size: "small",
                      checked: !!actualLicense,
                      onChange: function (e, checked) {
                        return setValue('actualLicense', checked ? LicenseType.Yes : LicenseType.No, {
                          shouldValidate: true
                        });
                      }
                    }),
                    label: t('actual')
                  })
                }), _jsx(Grid, {
                  children: _jsx(FormControlLabel, {
                    control: _jsx(Checkbox, {
                      size: "small",
                      checked: !!multiGeoEnabled,
                      onChange: function (e, checked) {
                        return setValue('multiGeoEnabled', checked, {
                          shouldValidate: true
                        });
                      }
                    }),
                    label: t('multiGeoLicense')
                  })
                }), _jsx(Grid, {
                  children: _jsx(FormControlLabel, {
                    control: _jsx(Checkbox, {
                      size: "small",
                      checked: !!dashboardLicense,
                      onChange: function (e, checked) {
                        return setValue('dashboardLicense', checked ? LicenseType.Yes : LicenseType.No, {
                          shouldValidate: true
                        });
                      }
                    }),
                    label: t('dashboards')
                  })
                })]
              })), _jsxs(Grid, __assign({
                item: true,
                xs: 6
              }, {
                children: [_jsx(Typography, __assign({
                  variant: "subtitle2"
                }, {
                  children: t('plannerLicenses')
                })), _jsxs(Box, __assign({
                  display: "flex",
                  flexDirection: "column",
                  gap: 1
                }, {
                  children: [_jsx(FormField, __assign({
                    name: "licensesUnlimited",
                    control: control
                  }, {
                    children: _jsxs(RadioGroup, __assign({
                      row: true
                    }, {
                      children: [_jsx(FormControlLabel, {
                        control: _jsx(Radio, {}),
                        label: t('plannerLicenseOption.limited'),
                        value: LicenseType.No
                      }), _jsx(FormControlLabel, {
                        control: _jsx(Radio, {}),
                        label: t('plannerLicenseOption.unlimited'),
                        value: LicenseType.Yes
                      })]
                    }))
                  })), !Number(licensesUnlimited) && _jsx(FormField, __assign({
                    required: true,
                    name: "numberOfLicenses",
                    label: t('numberOfLicenses'),
                    control: control
                  }, {
                    children: _jsx(NumberInput, {
                      min: 1,
                      max: 999
                    })
                  }))]
                }))]
              }))]
            }))]
          }))]
        }))
      }), _jsxs(DialogActions, __assign({
        sx: {
          justifyContent: 'space-between'
        }
      }, {
        children: [_jsx(Button, __assign({
          variant: "outlined",
          onClick: onClose
        }, {
          children: t('translation:action.cancel')
        })), _jsx(LoadingButton, __assign({
          variant: "contained",
          type: "submit",
          loading: addCompanyData.requesting
        }, {
          children: t('translation:action.save')
        }))]
      }))]
    }))
  }));
};